import React from "react";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuildingColumns, faChevronRight, faFileImage, faFileInvoiceDollar, faHandHoldingDollar, faSackDollar } from "@fortawesome/free-solid-svg-icons";
import { useT } from "../i18n";

const walletItems = [
  { to: '/add_fund_auto', icon: faSackDollar, title: 'Add Fund', subtitle: 'Instant deposit via UPI / QR Code' },
  { to: '/add_fund_user', icon: faFileImage, title: 'Manual Deposit', subtitle: 'Upload your payment screenshot' },
  { to: '/withdraw', icon: faHandHoldingDollar, title: 'Withdraw Fund', subtitle: 'Fast and secure withdrawal to bank' },
  { to: '/fund_histry/ALL_FUND_HISTROY', icon: faFileInvoiceDollar, title: 'Deposit & Withdraw History', subtitle: 'Check your past transactions statement' },
  { to: '/add_bank_details', icon: faBuildingColumns, title: 'Add Bank Details', subtitle: 'Update bank account for instant payouts' },
];

const MenuCard = ({ to, icon, title, subtitle }) => {
  const { t } = useT();
  return (
  <Link to={to} className="menu-card">
    <span className="menu-card-icon"><FontAwesomeIcon icon={icon} /></span>
    <span className="menu-card-text">
      <strong>{t(title)}</strong>
      <span>{t(subtitle)}</span>
    </span>
    <span className="menu-card-chevron"><FontAwesomeIcon icon={faChevronRight} /></span>
  </Link>
  );
};

const WalletMethod = () => (
  <div className="menu-list">
    {walletItems.map((item) => <MenuCard key={item.to} {...item} />)}
  </div>
);

export default WalletMethod;
